module.exports = __webpack_public_path__ + "img/10.e6adf14c.png";